module.exports = __webpack_public_path__ + "static/media/timelapse_28.7bf2317f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_28.jpg
// module id = 986
// module chunks = 0